import { AbsoluteCenter, Box, Spacer, Switch, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export const IndicatorHeader = ({
  editMode,
  setEditMode,
}: {
  editMode: boolean;
  setEditMode: (details: any) => void;
}) => {
  const { t } = useTranslation();

  return (
    <Box px={8} w={'full'} shadow="lg" pos={'relative'} h={'72px'}>
      <AbsoluteCenter axis="vertical" w={'calc(100% - var(--r3-spacing-12))'}>
        <Box ml={{ base: 10, md: 0 }}>
          <Text fontSize="xl" fontWeight="bold" color="gray.700">
            {t('pageTitle.csr_plan')}
          </Text>
        </Box>
        <Spacer />
        <Switch.Root mr={4} checked={editMode} onCheckedChange={(e) => setEditMode(e.checked)} colorPalette="primary">
          <Switch.HiddenInput />
          <Switch.Label>Mode édition</Switch.Label>
          <Switch.Control />
        </Switch.Root>
      </AbsoluteCenter>
    </Box>
  );
};

export default IndicatorHeader;
